<template lang="pug" src="./reports-editor.pug"></template>
<style lang="scss" src="./reports-editor.scss" scoped> </style>

<script>
import { mapState } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, maxLength } from 'vuelidate/lib/validators';
import validate from '@/mixins/validate';

import request from '@/utils/request';

export default {
    mixins: [validationMixin, validate],
    data: () => ({
        report: {
            name: '',
            category: null,
            sqlQuery: '',
            meta: '',
            useDates: false,
            useTimes: false,
            useQuery: false,
            useBrand: false,
            useCorp: false,
            useCompany: false
        },
        loaded: false,
        canSaveReport: false,
        removeModal: false,
        requestProcessing: false
    }),
    validations: {
        report: {
            name: {
                required,
                maxLength: maxLength(255)
            },
            category: {
                maxLength: maxLength(255)
            },
            sqlQuery: {
                required
            }
        }
    },
    computed: {
        ...mapState({
            reportsCategories: state => {
                const categories = state.reports.categories;
                if (!categories) {
                    return [];
                }

                return categories.filter(it => !!it);
            }
        }),
        saveMethod() {
            return this.report.id ? 'put' : 'post';
        },
        saveUrl() {
            return this.report.id ? `/admin/reports/${this.report.id}` : '/admin/reports/';
        },
    },
    watch: {
        report: {
            handler: function() {
                this.canSaveReport = true;
            },
            deep: true
        }
    },
    created() {
        if (this.$route.params.id) {
            this.loaded = true;
            this.loadData();
        }

        this.$store.dispatch('reports/getReportsCategories');
    },
    methods: {
        async loadData() {
            await request({ method: 'get', url: `/admin/reports/${this.$route.params.id}` })
                .then(res => this.successLoad(res)).catch(error => {
                    if(error.response && error.response.data && error.response.data.error) {
                        this.$store.dispatch('alert/addMessage', {
                            message: error.response.data.error
                        });
                    }
                });
        },

        async createOrSaveReport() {
            if (this.$v.report.$invalid) {
                this.$v.report.$touch();

                this.$nextTick(() => this.focusFirstErrorInput());
                return;
            }

            if (this.requestProcessing) return;

            this.requestProcessing = true;

            await request({ method: this.saveMethod, url: this.saveUrl, data: this.report })
                .then(res => {
                    this.successLoad(res);

                    if (!this.$route.params.id) {
                        this.$router.push(`/reports/editor/${this.report.id}`);
                    }

                    this.$store.dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    });
                }).catch(error => {
                    if(error.response && error.response.data && error.response.data.error) {
                        this.$store.dispatch('alert/addMessage', {
                            message: error.response.data.error
                        });
                    }
                }).finally(() => {
                    this.$nextTick(() => {
                        this.requestProcessing = false;
                    });
                });
        },

        successLoad(res) {
            this.report = Object.assign({}, this.report, res.data);

            this.$nextTick(() => {
                this.canSaveReport = false;
            });
        },

        async remove() {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            await request({ method: 'delete', url: `/admin/reports/${this.report.id}` })
                .then(() => {
                    this.$router.push(`/reports/list`);
                }).catch(error => {
                    if(error.response && error.response.data && error.response.data.error) {
                        this.$store.dispatch('alert/addMessage', {
                            message: error.response.data.error
                        });
                    }
                }).finally(() => {
                    this.$nextTick(() => {
                        this.requestProcessing = false;
                    });
                });
        }
    }
};
</script>
